module.exports = __webpack_public_path__ + "static/media/duckduckgo.86586f8c.svg";